import React, { useState, useEffect } from 'react';
import { Rate } from 'antd';

const RatingCustomField = ({ value, onChange, field }) => {
    const [localValue, setLocalValue] = useState(value || 0);

    useEffect(() => {
        setLocalValue(value || 0);
    }, [value]);

    const handleChange = (newValue) => {
        setLocalValue(newValue);
        if (field?._id) {
            onChange(field._id, newValue);
        } else {
            onChange(newValue);
        }
    };

    return (
        <div className="flex items-center" style={{ padding: '8px 12px', minHeight: 40 }} onClick={(e) => e.stopPropagation()}>
            <Rate value={localValue} onChange={handleChange} style={{ fontSize: 16 }} />
        </div>
    );
};

export default RatingCustomField;